import React from 'react';
import type { IaHandoffBin } from '../../../types';

const SIZE = 22;
const S = 1.8;

/** Ícones de bin de handoff (GHI-FunilAI); `optout` = cartão comercial. */
export const HandoffBinIcon: React.FC<{ kind: IaHandoffBin; className?: string }> = ({ kind, className }) => {
  switch (kind) {
    case 'human':
      return (
        <svg
          width={SIZE}
          height={SIZE}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={S}
          strokeLinecap="round"
          strokeLinejoin="round"
          className={className}
          aria-hidden
        >
          <path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm18 0h-3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-5Z" />
          <path d="M21 11V8a9 9 0 0 0-18 0v3" />
        </svg>
      );
    case 'inactive':
      return (
        <svg
          width={SIZE}
          height={SIZE}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={S}
          strokeLinecap="round"
          strokeLinejoin="round"
          className={className}
          aria-hidden
        >
          <circle cx="12" cy="12" r="9" />
          <polyline points="12 7 12 12 15 14" />
        </svg>
      );
    case 'lowintent':
      return (
        <svg
          width={SIZE}
          height={SIZE}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={S}
          strokeLinecap="round"
          strokeLinejoin="round"
          className={className}
          aria-hidden
        >
          <path d="M9 18a3 3 0 0 0 6 0V8a3 3 0 1 0-6 0z" />
          <circle cx="10" cy="11" r=".5" fill="currentColor" />
          <circle cx="14" cy="11" r=".5" fill="currentColor" />
        </svg>
      );
    case 'optout':
      return (
        <svg
          width={SIZE}
          height={SIZE}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={S}
          strokeLinecap="round"
          strokeLinejoin="round"
          className={className}
          aria-hidden
        >
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <line x1="3" y1="10" x2="21" y2="10" />
          <line x1="8" y1="7" x2="16" y2="15" />
        </svg>
      );
    case 'toxic':
      return (
        <svg
          width={SIZE}
          height={SIZE}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={S}
          strokeLinecap="round"
          strokeLinejoin="round"
          className={className}
          aria-hidden
        >
          <path d="M12 2l9 16H3z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <circle cx="12" cy="16" r=".6" fill="currentColor" />
        </svg>
      );
    default:
      return null;
  }
};
